import Menu from '@/global/components/MenuV2'
import { FormField } from 'global/components/Form'
import { useAuth } from 'hooks'

interface IProps {
    required?: boolean
}

export function SelectCategorias({ required }: IProps) {
    const {
        decoded: { categoria },
    } = useAuth()

    return (
        <FormField
            required={required}
            select
            name="categoriaId"
            label="Categoria de acesso"
        >
            <Menu.Item value={3}>Cliente</Menu.Item>
            <Menu.Item value={6}>Avaliação</Menu.Item>
            {categoria !== 7 && <Menu.Item value={7}>Representante</Menu.Item>}
        </FormField>
    )
}
